import { render, staticRenderFns } from "./DiscussionsNewTopicModal.vue?vue&type=template&id=6637367c&scoped=true&"
import script from "./DiscussionsNewTopicModal.vue?vue&type=script&lang=js&"
export * from "./DiscussionsNewTopicModal.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionsNewTopicModal.vue?vue&type=style&index=0&id=6637367c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6637367c",
  null
  
)

component.options.__file = "DiscussionsNewTopicModal.vue"
export default component.exports